import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { Talep } from '../model/talep';
import { Siparis } from 'src/model/siparis';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-talep-detay',
  templateUrl: './talep-detay.component.html',
  styleUrls: ['./talep-detay.component.css']
})
export class TalepDetayComponent implements OnInit {
  isAuthenticated = false;
  talep: Talep = null;
  siparis: Siparis = null;
  aciklama: string;
  teslimYeri: string;

  @Output() emittedAciklama = new EventEmitter<string>();
  // restService: any;

  @Input()
  public set source(talepData: Talep) {
    if (talepData != null) {
      this.talep = talepData;
    }
  }

  @Input()
  public set source2(siparisData: Siparis) {
    if (siparisData != null) {
      this.siparis = siparisData;
    }
  }

  @Input()
  public set source3(teslimYeri: string) {
    if (teslimYeri != null) {
      this.teslimYeri = teslimYeri;
    }
  }

  constructor(private authService: AuthService,
    private router: Router,
    private restService: RestService) {
  }

  ngOnInit(): void {
    this.isAuthenticated = this.authService.isLoggedIn();
  }

  talepGit() {
    this.router.navigate(['talep'], { queryParams: { id: this.talep.id } });
  }

  get teslimSuresi() {
    if (this.siparis !== null && this.siparis.olusturmaTarihi !== null) {
      let date = new Date(this.siparis.olusturmaTarihi);
      date.setDate(date.getDate() + this.siparis.talep.teklifler[0].teslimSuresi)
      return date;
    }
  }

  setAciklama() {
    this.emittedAciklama.emit(this.aciklama);
  }
  
  downloadFile(fileName: string) {
    this.restService.downloadFile(fileName).subscribe(res => {

    });
  }
}
